import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface MessagePopup {
  id: string;
  message: string;
  type: 'error' | 'warning' | 'success' | 'info';
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class PopupInfoService {
  private messagesSubject = new BehaviorSubject<MessagePopup[]>([]);
  readonly messages$ = this.messagesSubject.asObservable();

  showError(message: string, duration = 5000): void {
    this.show(message, 'error', duration);
  }

  showWarning(message: string, duration = 5000): void {
    this.show(message, 'warning', duration);
  }

  showSuccess(message: string, duration = 3000): void {
    this.show(message, 'success', duration);
  }

  showInfo(message: string, duration = 3000): void {
    this.show(message, 'info', duration);
  }

  private show(message: string, type: MessagePopup['type'], duration: number): void {
    const id = `${Date.now()}-${Math.random()}`;
    const messagePopup: MessagePopup = { id, message, type, duration };

    // Limpiar mensajes anteriores para mostrar solo uno a la vez
    this.messagesSubject.next([messagePopup]);

    if (duration > 0) {
      setTimeout(() => {
        this.dismiss(id);
      }, duration);
    }
  }

  dismiss(id: string): void {
    const currentMessages = this.messagesSubject.value;
    this.messagesSubject.next(currentMessages.filter((m) => m.id !== id));
  }

  clear(): void {
    this.messagesSubject.next([]);
  }
}
